// extracted by mini-css-extract-plugin
export default {"listItem":"TherapeuticClassList_listItem__bAk70"};